import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import L from "leaflet";
import MapWithCustomMarkers from "components/OverviewPages/Map/MapWithCustomMarkers";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";

export function OverviewMapPanel(props) {
  const [mapProps, setMapProps] = useState();

  useEffect(() => {
    let mapProps;
    mapProps = {
      markers: props.data?.map(result => {
        const isMarkerSelected =
          result.marker &&
          props.selectedMarker &&
          result.isMarkerSelected(result.marker, props.selectedMarker);

        return {
          latitude: result?.latitude ?? 0,
          longitude: result?.longitude ?? 0,
          interactive: true,
          hasCustomPopup: false,
          name: result.name,
          showPopupOnHover: false,
          bubblingMouseEvents: false,
          noTooltip: true,
          icon: () =>
            L.icon({
              className: "leaflet-clickable-marker",
              iconUrl: isMarkerSelected
                ? "/assets/map/markerSelected.webp"
                : "/assets/map/marker.webp",
              iconSize: isMarkerSelected ? [64, 64] : [24, 23]
            }),
          onClick: props?.onChangeMarker
            ? () => props.onChangeMarker(result.marker)
            : null
        };
      }),
      startingZoom: 4,
      clusterMarkers: false,
      selectedMarker: props.selectedMarker
    };
    setMapProps(mapProps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data, props.selectedMarker]);

  return (
    <MapCard>
      <MapWithCustomMarkers {...mapProps} />
    </MapCard>
  );
}

OverviewMapPanel.propTypes = {
  data: PropTypes.array,
  selectedMarker: PropTypes.string,
  onChangeMarker: PropTypes.func
};

const MapCard = styled(Card)`
  margin-top: 0;
  height: calc(100vh - 8rem - 123px);
  margin-bottom: 0;
`;
